import {
  type MerchantGroupQueryParam,
  MerchantGroupQueryParamName,
} from "src/merchantgroups/objects/MerchantGroupQueryParam";
import type {
  IMerchantAbstract,
  IMerchantAbstractNew,
} from "src/merchants/objects/Merchant";
import {
  type MerchantQueryParam,
  MerchantQueryParamName,
} from "src/merchants/objects/MerchantQueryParam";
import {
  GetPathWithParams,
  type QueryParams,
} from "src/utilities/URLParamsUtils";

export const MERCHANTS_VIEW_PATH = "/me";

/**
 * @deprecated
 */
export function getMerchantsViewPath(merchantGroup?: MerchantGroupQueryParam) {
  const queryParams: QueryParams = {};

  // Get Merchant Group UUID.
  if (merchantGroup) {
    if (typeof merchantGroup === "string") {
      queryParams[MerchantGroupQueryParamName] = merchantGroup;
    } else {
      queryParams[MerchantGroupQueryParamName] =
        merchantGroup.merchantGroupUUID;
    }
  }

  return GetPathWithParams(MERCHANTS_VIEW_PATH, queryParams);
}

export const getMerchantTabPath = (
  path,
  merchant?: MerchantQueryParam,
  merchantGroup?: MerchantGroupQueryParam,
) => {
  const queryParams: QueryParams = {};

  // Get Merchant UUID.
  if (merchant) {
    if (typeof merchant === "string") {
      queryParams[MerchantQueryParamName] = merchant;
    } else {
      queryParams[MerchantQueryParamName] = merchant.merchantUUID;
    }
  }

  // Get Merchant Group UUID.
  if (merchantGroup) {
    if (typeof merchantGroup === "string") {
      queryParams[MerchantGroupQueryParamName] = merchantGroup;
    } else {
      queryParams[MerchantGroupQueryParamName] =
        merchantGroup.merchantGroupUUID;
    }
  }

  return GetPathWithParams(path, queryParams);
};

export const MERCHANT_DETAIL_VIEW_PATH = "/me/:merchantUUID";

export const getMerchantAbstract = (
  merchant: IMerchantAbstract | IMerchantAbstractNew,
): IMerchantAbstract => {
  if ((merchant as IMerchantAbstract).merchantUUID) {
    return merchant as IMerchantAbstract;
  }
  return {
    merchantName: merchant.merchantName,
    merchantUUID: (merchant as IMerchantAbstractNew).merchantUuid,
  };
};

/**
 * @deprecated
 */
export function getMerchantDetailViewPath(
  merchant: IMerchantAbstract | IMerchantAbstractNew,
  merchantGroup?: MerchantGroupQueryParam,
) {
  const queryParams: QueryParams = {};

  // Get Merchant Group UUID.
  if (merchantGroup) {
    if (typeof merchantGroup === "string") {
      queryParams[MerchantGroupQueryParamName] = merchantGroup;
    } else {
      queryParams[MerchantGroupQueryParamName] =
        merchantGroup.merchantGroupUUID;
    }
  }

  return GetPathWithParams(
    MERCHANT_DETAIL_VIEW_PATH.replace(
      ":merchantUUID",
      getMerchantAbstract(merchant).merchantUUID,
    ),
    queryParams,
  );
}

export const CREATE_MERCHANT_VIEW_PATH = "/me/create";

/**
 * @deprecated
 */
export function getCreateMerchantViewPath(
  merchantGroup?: MerchantGroupQueryParam,
) {
  const queryParams: QueryParams = {};

  // Get Merchant Group UUID.
  if (merchantGroup) {
    if (typeof merchantGroup === "string") {
      queryParams[MerchantGroupQueryParamName] = merchantGroup;
    } else {
      queryParams[MerchantGroupQueryParamName] =
        merchantGroup.merchantGroupUUID;
    }
  }

  return GetPathWithParams(CREATE_MERCHANT_VIEW_PATH, queryParams);
}

export const EDIT_MERCHANT_VIEW_PATH: string = "/me/:merchantUUID/edit";
